import React from 'react'
import { useAuth } from './AuthContext'
import { getVisibleMetadataKeys, setVisibleMetadataKeys } from '../utils/indexedDB'

const MetadataVisibilityContext = React.createContext()

function MetadataVisibilityProvider({ children }) {
	const { loggedUser } = useAuth()
	const [visibleKeys, setVisibleKeys] = React.useState([])

	React.useEffect(() => {
		if (loggedUser?.id) {
			getVisibleMetadataKeys(loggedUser.id).then(setVisibleKeys)
		}
	}, [loggedUser?.id])

	const toggleKey = React.useCallback(
		(key) => {
			setVisibleKeys((prev) => {
				const next = prev.includes(key)
					? prev.filter((k) => k !== key)
					: [...prev, key]
				if (loggedUser?.id) {
					setVisibleMetadataKeys(loggedUser.id, next)
				}
				return next
			})
		},
		[loggedUser?.id]
	)

	const isKeyVisible = React.useCallback(
		(key) => visibleKeys.includes(key),
		[visibleKeys]
	)

	const value = React.useMemo(
		() => ({ visibleKeys, toggleKey, isKeyVisible }),
		[visibleKeys, toggleKey, isKeyVisible]
	)

	return (
		<MetadataVisibilityContext.Provider value={value}>
			{children}
		</MetadataVisibilityContext.Provider>
	)
}

function useMetadataVisibility() {
	const context = React.useContext(MetadataVisibilityContext)
	if (context === undefined) {
		return {
			visibleKeys: [],
			toggleKey: () => {},
			isKeyVisible: () => false,
		}
	}
	return context
}

export { MetadataVisibilityProvider, useMetadataVisibility }
